const benefits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Бесплатный трафик навсегда',
    text: 'В отличие от контекстной рекламы, где звонки прекращаются, как только кончились деньги на балансе, SEO-статья работает 24/7 годами. Вы платите один раз за создание — и получаете лиды «бесплатно».',
    accent: 'ROI навсегда',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Работа с «холодным» спросом (Лестница Бена Ханта)',
    text: 'Статьи цепляют людей на 2-й и 3-й ступенях — когда ваши клиенты еще только изучают проблему. Если вы поможете им советом в статье, они купят именно у вас, когда созреют.',
    accent: 'Утепление ЦА',
  },
  {
    icon: 'ri-award-line',
    title: 'Статус эксперта',
    text: 'Статья с глубоким разбором темы снимает возражения и вызывает доверие к вашему бренду еще до первого звонка. Клиент приходит подготовленным — продавать легче.',
    accent: 'Доверие',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Доминирование в поиске',
    text: 'Чем больше качественных статей, тем выше поисковики (Google, Яндекс) ценят ваш сайт в целом, поднимая и основные коммерческие страницы.',
    accent: 'Рост позиций',
  },
];

export default function SEOArticleWhatIs() {
  return (
    <section id="seo-what-is" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Что такое SEO-тексты и как они работают
            <span className="block md:inline"> на ваш бизнес?</span>
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
          <p className="text-sm sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Это не «заполнение сайта текстом» — это создание долгосрочного актива, который генерирует бесплатные заявки годами.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
          {benefits.map((b, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 sm:p-8 border border-gray-100 hover:border-[#C5A880]/40 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-[#1A2B4C] group-hover:bg-[#C5A880] transition-colors duration-300 flex items-center justify-center">
                  <i className={`${b.icon} text-base sm:text-xl text-white`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <h3 className="text-sm sm:text-base font-bold text-[#1A2B4C] font-['Playfair_Display'] leading-snug">
                      {b.title}
                    </h3>
                    <span className="text-xs font-semibold text-[#C5A880] bg-[#C5A880]/10 px-2 py-0.5 rounded-full font-['Montserrat'] whitespace-nowrap">
                      {b.accent}
                    </span>
                  </div>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed font-['Montserrat'] text-justify">
                    {b.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl p-6 sm:p-10 text-center">
          <p className="text-white/80 text-xs font-['Montserrat'] uppercase tracking-widest font-semibold mb-3">
            Ключевой принцип
          </p>
          <h3 className="text-base sm:text-2xl md:text-3xl font-['Playfair_Display'] font-bold text-white leading-snug">
            Рекламный бюджет закончился — реклама остановилась.
            <span className="block sm:inline"><br className="hidden sm:block" />SEO-статья закончилась — она продолжает приносить клиентов.</span>
          </h3>
        </div>
      </div>
    </section>
  );
}
